module.exports = __webpack_public_path__ + "img/insta.f6000eb7.svg";